class ShippingProtection {
  constructor() {
    this.checkbox = document.getElementById('shipping-protection-checkbox');
    this.container = document.querySelector('[data-shipping-protection]');
    this.loadingIndicator = this.container?.querySelector('.wt-shipping-protection__loading');
    this.isProcessing = false;
    
    console.log('[Shipping Protection] Initializing...', {
      checkbox: this.checkbox,
      container: this.container
    });
    
    if (this.checkbox) {
      this.init();
    }
  }

  init() {
    console.log('[Shipping Protection] Init called');
    
    // Reset processing flag in case page was reloaded after navigation
    this.isProcessing = false;
    
    // Check if protection product is currently in cart
    this.checkIfProtectionInCart().then(inCart => {
      console.log('[Shipping Protection] Protection in cart:', inCart);
      
      if (inCart) {
        // Product is in cart - clear localStorage and hide checkbox
        // (checkbox is already hidden by Liquid, but clear state)
        localStorage.removeItem('shipping_protection_selected');
        console.log('[Shipping Protection] Product in cart, cleared localStorage');
      } else {
        // Product NOT in cart - check if we just came from a session where it was added
        // If localStorage says true but product isn't in cart, it means user removed it
        const savedState = localStorage.getItem('shipping_protection_selected');
        const wasAddedBefore = localStorage.getItem('shipping_protection_was_added');
        
        if (wasAddedBefore === 'true' && savedState === 'true') {
          // User removed the product - clear the selection
          console.log('[Shipping Protection] Product was removed, clearing selection');
          localStorage.removeItem('shipping_protection_selected');
          localStorage.removeItem('shipping_protection_was_added');
          this.checkbox.checked = false;
        } else if (savedState !== null) {
          // Normal case - restore saved state
          this.checkbox.checked = savedState === 'true';
          console.log('[Shipping Protection] Restored state:', savedState);
        }
      }
    });
    
    // Handle checkbox change (only if not already attached)
    if (!this.checkbox.dataset.listenerAttached) {
      this.checkbox.dataset.listenerAttached = 'true';
      
      this.checkbox.addEventListener('change', () => {
        console.log('[Shipping Protection] Checkbox changed:', this.checkbox.checked);
        localStorage.setItem('shipping_protection_selected', this.checkbox.checked);
      });
    }
    
    // Use a more aggressive approach - intercept ALL clicks on the document
    this.interceptCheckoutGlobal();
    
    // Also try form interception as backup
    this.interceptCheckout();
  }
  
  async checkIfProtectionInCart() {
    try {
      const variantId = this.checkbox.dataset.variantId;
      if (!variantId) {
        console.warn('[Shipping Protection] No variant ID to check');
        return false;
      }
      
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const protectionItem = cart.items.find(item => 
        item.variant_id == variantId || 
        (item.properties && item.properties._shipping_protection === 'true')
      );
      
      console.log('[Shipping Protection] Check result:', {
        variantId,
        found: !!protectionItem,
        cartItems: cart.items.length
      });
      
      return !!protectionItem;
    } catch (error) {
      console.error('[Shipping Protection] Error checking cart:', error);
      return false;
    }
  }
  
  interceptCheckoutGlobal() {
    // Use a property on the document object instead of dataset
    if (document._shippingProtectionGlobalAttached) {
      console.log('[Shipping Protection] Global interceptor already attached');
      return;
    }
    
    document._shippingProtectionGlobalAttached = true;
    console.log('[Shipping Protection] Setting up global click interceptor');
    
    document.addEventListener('click', async (event) => {
      const target = event.target;
      
      // Get the current instance's checkbox (might have changed)
      const currentCheckbox = document.getElementById('shipping-protection-checkbox');
      if (!currentCheckbox) {
        // Silently return if no checkbox (it's hidden)
        return;
      }
      
      // Check if the clicked element or any parent is a checkout button
      let element = target;
      let isCheckoutButton = false;
      let checkoutButton = null;
      
      while (element && element !== document) {
        if (element.tagName === 'BUTTON' || element.tagName === 'A') {
          const buttonText = element.textContent.trim().toLowerCase();
          const ariaLabel = element.getAttribute('aria-label')?.toLowerCase() || '';
          
          // More strict checkout detection - exclude "view cart" buttons
          const isCheckout = (
            (element.name === 'checkout' ||
            element.id === 'CartDrawer-Checkout' ||
            element.classList.contains('cart__checkout') ||
            buttonText.includes('check out') ||
            ariaLabel.includes('check out')) &&
            // Exclude view cart buttons
            !element.classList.contains('wt-cart__show-cart') &&
            !buttonText.includes('view cart') &&
            !ariaLabel.includes('view cart')
          );
          
          if (isCheckout) {
            isCheckoutButton = true;
            checkoutButton = element;
            console.log('[Shipping Protection] GLOBAL: Detected checkout button:', {
              text: buttonText,
              ariaLabel: ariaLabel,
              id: element.id,
              name: element.name,
              classes: element.className
            });
            break;
          }
        }
        element = element.parentElement;
      }
      
      if (isCheckoutButton) {
        // Get the current instance
        const instance = shippingProtectionInstance;
        
        console.log('[Shipping Protection] GLOBAL: Checkout button clicked!', {
          button: checkoutButton,
          checked: currentCheckbox?.checked,
          hasInstance: !!instance,
          processing: instance?.isProcessing
        });
        
        if (currentCheckbox && currentCheckbox.checked) {
          console.log('[Shipping Protection] GLOBAL: === Checkbox is checked, preparing to intercept ===');
          
          if (!instance) {
            console.error('[Shipping Protection] GLOBAL: No instance available!');
            return;
          }
          
          console.log('[Shipping Protection] GLOBAL: Instance found:', instance);
          console.log('[Shipping Protection] GLOBAL: Instance isProcessing before reset:', instance.isProcessing);
          
          // Always reset processing flag before starting
          instance.isProcessing = false;
          
          console.log('[Shipping Protection] GLOBAL: Intercepting checkout (preventing default)');
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          // Update instance references to current elements
          instance.checkbox = currentCheckbox;
          instance.container = document.querySelector('[data-shipping-protection]');
          instance.loadingIndicator = instance.container?.querySelector('.wt-shipping-protection__loading');
          
          console.log('[Shipping Protection] GLOBAL: Updated instance references');
          console.log('[Shipping Protection] GLOBAL: Calling addProtectionAndCheckout...');
          
          try {
            await instance.addProtectionAndCheckout(checkoutButton);
            console.log('[Shipping Protection] GLOBAL: addProtectionAndCheckout completed');
          } catch (error) {
            console.error('[Shipping Protection] GLOBAL: Error in addProtectionAndCheckout:', error);
            // Still try to proceed to checkout
            window.location.href = '/checkout';
          }
        } else {
          console.log('[Shipping Protection] GLOBAL: Checkbox not checked or not found, allowing normal checkout');
        }
      }
    }, true); // Capture phase - fires before any other handlers
  }


  interceptCheckout() {
    // Find forms that submit to checkout
    const cartForms = document.querySelectorAll('#CartDrawer-Form, #cart, form[action*="cart"]');
    
    console.log('[Shipping Protection] Found cart forms:', cartForms.length, cartForms);
    
    cartForms.forEach((form, index) => {
      if (!form.dataset.shippingProtectionAttached) {
        form.dataset.shippingProtectionAttached = 'true';
        
        console.log(`[Shipping Protection] Attaching listener to form ${index}:`, form);
        
        form.addEventListener('submit', async (event) => {
          // Check if this is a checkout submission
          const submitter = event.submitter;
          const isCheckout = submitter && (
            submitter.name === 'checkout' || 
            submitter.classList.contains('cart__checkout') ||
            submitter.id === 'CartDrawer-Checkout'
          );
          
          console.log('[Shipping Protection] Form submitted!', {
            isCheckout,
            submitter,
            checked: this.checkbox?.checked,
            processing: this.isProcessing
          });
          
          if (isCheckout && this.checkbox && this.checkbox.checked && !this.isProcessing) {
            console.log('[Shipping Protection] Intercepting checkout to add protection');
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            await this.addProtectionAndCheckout(form);
          }
        }, true); // Use capture phase
      }
    });
    
    // Also try direct button interception as fallback
    const checkoutButtons = document.querySelectorAll(
      '#CartDrawer-Checkout, .cart__checkout, button[name="checkout"]'
    );
    
    console.log('[Shipping Protection] Found checkout buttons:', checkoutButtons.length, checkoutButtons);
    
    checkoutButtons.forEach((button, index) => {
      if (!button.dataset.shippingProtectionButtonAttached) {
        button.dataset.shippingProtectionButtonAttached = 'true';
        
        console.log(`[Shipping Protection] Attaching listener to button ${index}:`, button, 'pointer-events:', window.getComputedStyle(button).pointerEvents);
        
        // Remove pointer-events: none if it exists
        if (button.style.pointerEvents === 'none') {
          console.warn('[Shipping Protection] Button has pointer-events: none, removing it');
          button.style.pointerEvents = 'auto';
        }
        
        button.addEventListener('click', async (event) => {
          console.log('[Shipping Protection] Checkout button clicked!', {
            checked: this.checkbox?.checked,
            processing: this.isProcessing
          });
          
          if (this.checkbox && this.checkbox.checked && !this.isProcessing) {
            console.log('[Shipping Protection] Intercepting checkout to add protection via button');
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            await this.addProtectionAndCheckout(button.form || button);
          }
        }, true);
      }
    });
  }

  async addProtectionAndCheckout(checkoutButton) {
    const variantId = this.checkbox?.dataset.variantId;
    
    console.log('[Shipping Protection] === START addProtectionAndCheckout ===');
    console.log('[Shipping Protection] Checkbox:', this.checkbox);
    console.log('[Shipping Protection] Variant ID:', variantId);
    console.log('[Shipping Protection] isProcessing:', this.isProcessing);
    console.log('[Shipping Protection] Button:', checkoutButton);
    
    if (!variantId) {
      console.warn('[Shipping Protection] No variant ID found, proceeding to checkout');
      this.proceedToCheckout(checkoutButton);
      return;
    }
    
    // Set processing flag
    this.isProcessing = true;
    this.setLoading(true);
    
    console.log('[Shipping Protection] Set isProcessing to true, starting API calls...');
    
    try {
      // Check if protection is already in cart
      console.log('[Shipping Protection] Fetching current cart...');
      let cartResponse = await fetch('/cart.js');
      let cart = await cartResponse.json();
      
      console.log('[Shipping Protection] Current cart has', cart.items.length, 'items');
      console.log('[Shipping Protection] Cart items:', cart.items.map(i => ({ id: i.variant_id, title: i.title })));
      
      let protectionItem = cart.items.find(item => 
        item.variant_id == variantId || 
        (item.properties && item.properties._shipping_protection === 'true')
      );
      
      console.log('[Shipping Protection] Protection already in cart?', !!protectionItem);
      
      if (!protectionItem) {
        console.log('[Shipping Protection] Protection NOT in cart, adding now...');
        console.log('[Shipping Protection] Calling /cart/add.js with variant:', variantId);
        
        // Add protection to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_shipping_protection': 'true'
            }
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error('[Shipping Protection] Failed to add:', errorData);
          throw new Error('Failed to add shipping protection');
        }
        
        const addedItem = await response.json();
        console.log('[Shipping Protection] Successfully added:', addedItem);
        
        // Mark that we've added the product
        localStorage.setItem('shipping_protection_was_added', 'true');
        
        // Verify the product was actually added with retries
        let retries = 0;
        let maxRetries = 5;
        let productAdded = false;
        
        while (retries < maxRetries && !productAdded) {
          await new Promise(resolve => setTimeout(resolve, 200));
          
          const verifyResponse = await fetch('/cart.js');
          const verifyCart = await verifyResponse.json();
          
          protectionItem = verifyCart.items.find(item => 
            item.variant_id == variantId || 
            (item.properties && item.properties._shipping_protection === 'true')
          );
          
          if (protectionItem) {
            productAdded = true;
            console.log('[Shipping Protection] Verified product in cart after', retries, 'retries');
          } else {
            retries++;
            console.log('[Shipping Protection] Retry', retries, '- product not in cart yet');
          }
        }
        
        if (!productAdded) {
          console.warn('[Shipping Protection] Could not verify product was added, proceeding anyway');
        }
      } else {
        console.log('[Shipping Protection] Product already in cart, skipping add');
      }
      
      // Proceed to checkout
      console.log('[Shipping Protection] === Proceeding to checkout ===');
      this.proceedToCheckout(checkoutButton);
      
    } catch (error) {
      console.error('[Shipping Protection] === ERROR in addProtectionAndCheckout ===');
      console.error('[Shipping Protection] Error details:', error);
      console.error('[Shipping Protection] Stack:', error.stack);
      
      this.isProcessing = false;
      this.setLoading(false);
      this.showError('Unable to add shipping protection. Proceeding to checkout...');
      
      // Still proceed to checkout even if protection fails
      setTimeout(() => {
        this.proceedToCheckout(checkoutButton);
      }, 1000);
    }
  }

  proceedToCheckout(formOrButton) {
    console.log('[Shipping Protection] Proceeding to checkout with:', formOrButton);
    
    // ALWAYS use direct window.location to ensure we go to checkout, not cart page
    // This prevents any confusion with view cart buttons or form actions
    console.log('[Shipping Protection] Navigating directly to /checkout');
    
    // Don't reset isProcessing here - we're navigating away anyway
    // It will be reset on next page load/init
    
    window.location.href = '/checkout';
  }


  setLoading(isLoading) {
    this.isProcessing = isLoading;
    
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = isLoading ? 'flex' : 'none';
    }
    
    if (this.checkbox) {
      this.checkbox.disabled = isLoading;
    }
    
    if (this.container) {
      this.container.classList.toggle('is-loading', isLoading);
    }
  }

  showError(message) {
    // Create a simple error toast
    const errorDiv = document.createElement('div');
    errorDiv.className = 'wt-shipping-protection-error';
    errorDiv.textContent = message;
    errorDiv.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #d32f2f;
      color: white;
      padding: 12px 24px;
      border-radius: 4px;
      z-index: 9999;
      animation: slideUp 0.3s ease;
    `;
    
    document.body.appendChild(errorDiv);
    
    setTimeout(() => {
      errorDiv.remove();
    }, 3000);
  }
}

// Initialize once on DOM ready
let shippingProtectionInstance = null;

function initShippingProtection() {
  const checkbox = document.getElementById('shipping-protection-checkbox');
  
  if (checkbox) {
    // Always recreate instance to get fresh state
    console.log('[Shipping Protection] Creating new instance');
    
    // Remove old initialized flag to allow re-initialization
    delete checkbox.dataset.initialized;
    delete checkbox.dataset.listenerAttached;
    
    shippingProtectionInstance = new ShippingProtection();
  } else {
    console.log('[Shipping Protection] No checkbox found (may be hidden because product is in cart)');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initShippingProtection);
} else {
  initShippingProtection();
}

// Reinitialize when cart drawer is opened/updated
document.addEventListener('cart:updated', () => {
  setTimeout(initShippingProtection, 100);
});

// Listen for cart updates (when items are added/removed)
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  console.log('[Shipping Protection] Subscribing to cart updates');
  subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
    console.log('[Shipping Protection] Cart updated event received:', event);
    
    // Check if shipping protection was removed
    const variantId = document.getElementById('shipping-protection-checkbox')?.dataset.variantId;
    
    if (variantId) {
      // Checkbox exists, protection not in cart
      console.log('[Shipping Protection] Checkbox exists after cart update - reinitializing');
      setTimeout(initShippingProtection, 100);
    } else {
      // Checkbox doesn't exist - check if protection product was removed
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // Try to find protection product by checking all items
        const hasProtection = cart.items.some(item => 
          item.properties && item.properties._shipping_protection === 'true'
        );
        
        if (!hasProtection) {
          console.log('[Shipping Protection] Protection removed from cart - refreshing cart drawer');
          
          // Clear flags
          localStorage.removeItem('shipping_protection_was_added');
          
          // Force refresh the cart drawer to show checkbox
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            // Trigger a refresh by fetching the updated cart-drawer section
            const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('cart-drawer');
            
            if (newDrawer) {
              // Preserve scroll position
              const scrollElement = cartDrawer.querySelector('.wt-cart__drawer__body');
              const scrollPos = scrollElement?.scrollTop || 0;
              
              // Replace inner content
              cartDrawer.innerHTML = newDrawer.innerHTML;
              
              // Restore scroll
              const newScrollElement = cartDrawer.querySelector('.wt-cart__drawer__body');
              if (newScrollElement) {
                newScrollElement.scrollTop = scrollPos;
              }
              
              console.log('[Shipping Protection] Cart drawer refreshed');
              setTimeout(initShippingProtection, 200);
            }
          }
        }
      } catch (error) {
        console.error('[Shipping Protection] Error handling cart update:', error);
      }
    }
  });
}

// Watch for cart drawer opening (mutation observer)
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
      const cartDrawer = mutation.target;
      if (cartDrawer.hasAttribute('open')) {
        console.log('[Shipping Protection] Cart drawer opened');
        setTimeout(initShippingProtection, 200);
      }
    }
  });
});

// Start observing cart drawer
const cartDrawer = document.querySelector('cart-drawer');
if (cartDrawer) {
  observer.observe(cartDrawer, { attributes: true });
  console.log('[Shipping Protection] Observing cart drawer');
}

